import { useState } from "react"
import { TextField, List, ListItem, ListItemText, Button, Switch, FormControlLabel, FormGroup, Select, MenuItem, FormControl, InputLabel, Badge, Checkbox, CircularProgress } from '@material-ui/core';
import {editDietInfo} from './index';
import { useNotify } from "react-admin";
export function IdentityInfo(props: any) {
    const { id, sid, firstName, lastName, gender, relation } = props
    let relationTypes = props.relationTypes
    let refetchChild = props.refetchChild
    let [isEditIdentityInfo, setIsEditIdentityInfo] = useState(false)
    let [isLoading, setIsLoading] = useState(false)
    const notify = useNotify()
    let [values, setValues] = useState<any>({
        identityId: id,
        firstName: firstName,
        lastName: lastName,
        relationType: Object.keys(relationTypes).find(key => relationTypes[key] === relation) || '',
    })
    const submitEdit = async(e: any) => {
        setIsLoading(true)
        try {
            const response = await editDietInfo(values)
            console.log("response",response);
            if (response && response.data.data && response.data.data.sid) {
                refetchChild()
                setIsLoading(false)
                setIsEditIdentityInfo(!isEditIdentityInfo)   
             
            }
            if (response && response.data.err) {
                setIsLoading(false)
                setIsEditIdentityInfo(!isEditIdentityInfo) 
                notify(` کد${response.data.err.code} - ${response.data.err.details.messages[0]}`)
            }  
          
        } catch (error) {
            setIsLoading(false)
            notify(`خطایی پیش آمده است`)
    
        }
     
        
    }
    const onChangeSelect = (e: any) => {
        setValues({ ...values, relationType: e.target.value })
    }
    return (
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }}>
            <div style={{ marginRight: "20px" }}>

                <Button style={{ width: "80px", height: "30px", borderRadius: "8px", marginLeft: "5px", background: "#d2d2d2", marginRight: "5px" }} onClick={() => setIsEditIdentityInfo(!isEditIdentityInfo)}> {isEditIdentityInfo ? "بازگشت" : "ویرایش"} </Button>
                {isEditIdentityInfo ?
                    <Button
                        style={{ width: "80px", height: "30px", borderRadius: "8px", marginLeft: "10px", border: "1px solid #63b8f3", marginRight: "5px" }}
                        color="primary"
                        onClick={(e) => submitEdit(e)}>   {isLoading ? <CircularProgress size={20} /> : <span>ثبت</span>}
                    </Button>
                    : <div></div>
                }
            </div>
            {isEditIdentityInfo ?
                <div>
                    <form style={{ display: "flex", flexDirection: "row" }} action="" onSubmit={(e) => submitEdit(e)}>
                        <FormControl style={{ fontFamily: "IranSans-Light", width: "100%", marginLeft: "5px" }}>
                            <InputLabel id="demo-simple-select-label">نوع رژیم</InputLabel>
                            <Select
                                style={{ fontFamily: "IranSans-Light",height:"40px" }}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                variant="outlined"
                                value={values.relationType}
                               
                                onChange={(e) => onChangeSelect(e)}
                            >
                                {Object.keys(relationTypes).map((key: string) => (
                                    <MenuItem key={key} value={key}>{relationTypes[key]}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <TextField
                            style={{ fontFamily: "IranSans-Light", marginLeft: "5px"}}
                            fullWidth
                            onChange={(e: any) => setValues({ ...values, firstName: e.target.value })}
                            value={values.firstName}
                            label="نام "
                            size="small"
                            variant="outlined">

                        </TextField>
                        <TextField
                            style={{ fontFamily: "IranSans-Light", marginLeft: "5px" }}
                            fullWidth
                            onChange={(e: any) => setValues({ ...values, lastName: e.target.value })}
                            value={values.lastName}
                            label="    نام خانوادگی"
                            size="small"
                            variant="outlined">

                        </TextField>
                    </form>
                </div> :
                <div style={{ fontFamily: "IranSans-Medium", fontSize: "12px", height: "41px", display: "flex", flexWrap: "wrap",alignItems:"center", padding: "7px", borderRadius: "4px" }}>
                    <div style={{ marginLeft: "5px" }}>   <span style={{ margin: "2px", fontWeight: "700" }}>شناسه :</span>  <span style={{ marginLeft: "4px", color: "#616161" }}>{id}</span></div>
                    <div style={{ marginLeft: "5px" }}><span style={{ margin: "2px", fontWeight: "700" }}>شناسه یکتا  :</span>  <span style={{ marginLeft: "4px", color: "#616161" }}>{sid}</span></div>
                    <div style={{ marginLeft: "5px" }}> <span style={{ margin: "2px", fontWeight: "700" }}>نام :</span>  <span style={{ marginLeft: "4px", color: "#616161" }}>{firstName}</span></div>
                    <div style={{ marginLeft: "5px" }}><span style={{ margin: "2px", fontWeight: "700" }}>نام خانوادگی :</span>  <span style={{ marginLeft: "4px", color: "#616161" }}>{lastName}</span></div>
                    <div style={{ marginLeft: "5px" }}> <span style={{ margin: "2px", fontWeight: "700" }}>جنسیت :</span>  <span style={{ marginLeft: "4px", color: "#616161" }}>{gender}</span></div>
                    <div style={{ marginLeft: "5px" }}><span style={{ margin: "2px", fontWeight: "700" }}>ارتباط :</span>  <span style={{ marginLeft: "4px", color: "#616161" }}>{relation}</span></div>
                </div>
            }


        </div>


    )
}